var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("notificator", {
        ref: "notifyImported",
        staticClass: "_mt-3",
        attrs: { singular: true, "can-close": false },
      }),
      _vm._v(" "),
      _c(
        "box",
        {
          attrs: { "data-qa": "project-user-pledge:CurrentPledgeBox" },
          scopedSlots: _vm._u([
            {
              key: "balloon",
              fn: function () {
                return [
                  _c("balloon-actions", {
                    attrs: {
                      actions: _vm.actions,
                      "balloon-style-props": _vm.balloonStyleProps,
                      mode: _vm.balloonActionsModes.grouped,
                      "data-qa": "project-user-pledge:BalloonActions",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm.isPledgePlaced && _vm.isOrderLoaded
            ? _c("project-user-pledge-meta", {
                attrs: {
                  pledge: _vm.metaPledgeModel,
                  "is-open-for-orders": _vm.isOpenForOrders,
                  "is-editing": _vm.canRevertChanges,
                  "is-expanded": _vm.isExpanded,
                  "is-expandable": _vm.isExpandable,
                  "can-proceed-to-checkout": _vm.canProceedToCheckout,
                  labels: _vm.labels,
                  "order-communications": _vm.orderCommunications,
                },
                on: {
                  "cta-triggered": _vm.onMetaCtaTriggered,
                  expand: _vm.onToggleMore,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isExpandable || _vm.isExpanded
            ? [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isPledgePlaced && _vm.isOrderLoaded,
                      expression: "isPledgePlaced && isOrderLoaded",
                    },
                  ],
                  staticClass: "gfu-box-divider _mb-2",
                }),
                _vm._v(" "),
                _vm.allItemsRemoved
                  ? [
                      _c(
                        "div",
                        { staticClass: "gfu-table" },
                        [
                          _c(
                            "empty-state",
                            {
                              attrs: {
                                description:
                                  _vm.Resources.YourPledge
                                    .EmptyPledgeRemovedAllItems,
                                "show-divider": false,
                                "data-qa": "project-user-pledge:EmptyState",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "_flexcntr _flexwrap" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--micro _ttl gfu-btn--thin gfu-empty-state-action _tlc",
                                      attrs: {
                                        href: _vm.addNewItemsUrl,
                                        "data-qa":
                                          "project-user-pledge-button:AddItems",
                                      },
                                    },
                                    [
                                      _c("base-icon", {
                                        staticClass: "gfu-btn__icon",
                                        attrs: { name: "plus" },
                                      }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.Resources.YourPledge
                                              .AddItemsButton
                                          ) +
                                          "\n                            "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "icon-base-button",
                                        {
                                          staticClass:
                                            "gfu-empty-state-action _tlc",
                                          attrs: {
                                            icon: "undo",
                                            "data-qa":
                                              "your-pledge-empty-state:RevertChanges",
                                          },
                                          on: { click: _vm.revertChanges },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.Resources.YourPledge
                                                .RevertChangesButton
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.pledge.canBeCanceled
                                        ? _c(
                                            "icon-base-button",
                                            {
                                              staticClass:
                                                "gfu-empty-state-action _tlc",
                                              attrs: {
                                                icon: "times",
                                                "data-qa":
                                                  "your-pledge-empty-state:CancelPledge",
                                              },
                                              on: { click: _vm.onCancelOrder },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.Resources.YourPledge
                                                    .CancelPledgeButton
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  : [
                      _vm.isPaymentInProcessingModeNotificatorVisible
                        ? _c(
                            "base-notificator",
                            {
                              staticClass: "_my-3",
                              attrs: { type: "info", "can-close": false },
                            },
                            [
                              _c(
                                "localize",
                                {
                                  attrs: {
                                    resource:
                                      _vm.Resources.YourPledge
                                        .YourPledgeProcessingPaymentDescription,
                                  },
                                },
                                [
                                  _c("span", { attrs: { "format-key": "0" } }, [
                                    _vm._v(
                                      _vm._s(_vm.maxProcessingTimeMinutes) +
                                        " " +
                                        _vm._s(_vm.pluralizedMinutesCountLabel)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "_tdu",
                                      attrs: { href: "#", "format-key": "1" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.openPaymentHistoryModal.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.Resources.YourPledge
                                              .YourPledgePaymentHistoryLabel
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canBeAborted
                        ? _c(
                            "base-notificator",
                            {
                              staticClass: "_my-3",
                              attrs: { type: "warning", "can-close": false },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: [
                                    "_flex _ai-c _jc-sb",
                                    { _flexcol: _vm.isMobile },
                                  ],
                                },
                                [
                                  _vm.hasMaxProcessingTime
                                    ? _c(
                                        "localize",
                                        {
                                          attrs: {
                                            resource:
                                              _vm.Resources.YourPledge
                                                .YourPledgeAbortPaymentDescription,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { attrs: { "format-key": "0" } },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.maxProcessingTimeMinutes
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.pluralizedMinutesCountLabel
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.Resources.YourPledge
                                                .YourPledgeAbortPaymentModalIssueWithPaymentDescription
                                            ) +
                                            "\n                        "
                                        ),
                                      ]),
                                  _vm._v(" "),
                                  _c(
                                    "base-button",
                                    {
                                      staticClass:
                                        "_shrink-0 _mt-2 _mt-0--m _ml-2--m",
                                      attrs: {
                                        theme: "transparentInverse",
                                        "data-qa": "your-pledge:AbortPayment",
                                      },
                                      on: { click: _vm.onAbortPayment },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.Resources.YourPledge
                                              .YourPledgeAbortPaymentButton
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("cart-table", {
                        key: _vm.pledge.orderPublicID,
                        attrs: {
                          "order-id": this.orderId,
                          mode: _vm.cartTableMode,
                        },
                        on: { "edit-pledge": _vm.onEditPledge },
                      }),
                      _vm._v(" "),
                      _vm.isProductRecommendationsVisible
                        ? _c("product-recommendation-slider", {
                            attrs: {
                              "order-code": _vm.orderCode,
                              "project-id": _vm.projectContext.projectID,
                              section: "upsells-your-pledge",
                              "extra-large-screen-visible-items-count": 3,
                              "large-screen-visible-items-count": 3,
                              quantity: 9,
                            },
                            on: { "product-added": _vm.onEditPledge },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("order-summary-list", {
                        attrs: { "order-id": _vm.orderId },
                      }),
                      _vm._v(" "),
                      _vm.isPledgePlaced
                        ? [
                            _c("order-details-summary", {
                              attrs: {
                                "order-details": _vm.pledge.pledgeDetails,
                                "order-id": _vm.pledge.orderID,
                                "can-add-more-items": _vm.pledge.canAddNewItems,
                                "can-cancel-order": _vm.pledge.canBeCanceled,
                                "is-order-locked": _vm.pledge.isLocked,
                              },
                              on: {
                                "cancel-order": _vm.onCancelOrder,
                                "add-items-to-order": _vm.onAddItemsToOrder,
                                "edit-pledge": _vm.onEditPledge,
                              },
                            }),
                            _vm._v(" "),
                            _vm.hasFullAddress
                              ? _c("order-details-shipping", {
                                  attrs: {
                                    "billing-address": _vm.billingAddress,
                                    "shipping-address": _vm.shippingAddress,
                                    "can-change-shipping-address":
                                      _vm.pledge.canChangeShipping,
                                  },
                                  on: {
                                    "change-shipping":
                                      _vm.onManageShippingAction,
                                  },
                                })
                              : _vm.hasPartialAddress
                              ? _c("order-partial-details-shipping", {
                                  attrs: {
                                    "shipping-address": _vm.shippingAddress,
                                    "shipping-model":
                                      _vm.pledge.pledgeDetails.shippingModel,
                                    "can-change-shipping-address":
                                      _vm.pledge.canChangeShipping,
                                  },
                                  on: {
                                    "change-shipping":
                                      _vm.onManageShippingAction,
                                  },
                                })
                              : _vm.hasAddressHidden
                              ? [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "gfu-heading gfu-heading--top-divider _mt-3 _mb-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.Resources.YourPledge
                                            .ShippingSectionHeader
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("base-icon", {
                                        attrs: { name: "circle-info" },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.shippingInfoNotification) +
                                          "\n                        "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasInstallmentsDetails
                              ? _c(
                                  "div",
                                  { ref: "installmentsPlanSection" },
                                  [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "gfu-heading gfu-heading--top-divider _mt-3 _mb-2",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.Resources.YourPledge
                                              .StretchPaySectionHeader
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.installmentPlans,
                                      function (installmentPlan) {
                                        return _c(
                                          "installments-details-with-progress",
                                          _vm._b(
                                            {
                                              key: installmentPlan.id,
                                              attrs: {
                                                "data-qa":
                                                  installmentPlan.dataQa,
                                              },
                                              on: {
                                                "installments-paid":
                                                  _vm.onInstallmentsPaid,
                                              },
                                            },
                                            "installments-details-with-progress",
                                            installmentPlan,
                                            false
                                          )
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasPaymentOverview
                              ? [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "gfu-heading gfu-heading--top-divider _mt-3",
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.Resources.YourPledge
                                              .PaymentMethodSectionHeader
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isPaymentMethodInstant
                                    ? [
                                        _c(
                                          "localize",
                                          {
                                            staticClass:
                                              "gfu-bt gfu-bt--b2 _mb-3 _mt-2",
                                            attrs: {
                                              tag: "div",
                                              resource:
                                                _vm.Resources.YourPledge
                                                  .PaymentMethodInfoInstantPaymentText,
                                            },
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "_tc--accent",
                                                attrs: {
                                                  href: _vm.projectContactUrl,
                                                  "format-key": "0",
                                                  "data-qa":
                                                    "your-pledge-link:ContactTheCreator",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.Resources.YourPledge
                                                      .PaymentMethodInfoInstantPaymentTextLink
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "_mt-4 _pa-4 _bg-color-light _brad--common",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "_flex _gap-2 _mb-4 _ai-c",
                                              },
                                              [
                                                _c("base-image", {
                                                  attrs: {
                                                    src: _vm
                                                      .paymentOverviewDetails
                                                      .imageUrl,
                                                    alt: _vm
                                                      .paymentOverviewDetails
                                                      .name,
                                                    height: "20",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "_tc--light" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .paymentOverviewDetails
                                                          .name
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "gfu-list _flexcol _gap-2",
                                              },
                                              _vm._l(
                                                _vm.paymentMethodDisclaimer,
                                                function (item) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: item.iconName,
                                                      staticClass: "_flex",
                                                    },
                                                    [
                                                      _c("base-icon", {
                                                        staticClass:
                                                          "_mr-2 _tc--accent _shrink-0 _py-h",
                                                        attrs: {
                                                          size: "lg",
                                                          "is-fixed-width": true,
                                                          name: item.iconName,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "_flex _ai-c",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.paragraph
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "gfu-bt gfu-bt--b2 _mb-3 _mt-2",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(_vm.paymentMethodInfo) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.changeCreditCard
                                          ? _c(
                                              "credit-card-overview",
                                              {
                                                attrs: {
                                                  "image-url":
                                                    _vm.paymentOverview
                                                      .cardImageUrl,
                                                  name: _vm.paymentOverview
                                                    .cardName,
                                                  "masked-number":
                                                    _vm.paymentOverview
                                                      .cardMaskedNumber,
                                                  "payment-data-source":
                                                    _vm.paymentOverview
                                                      .paymentDataSource,
                                                  "payment-data-source-image-url":
                                                    _vm.paymentOverview
                                                      .paymentDataSourceImageUrl,
                                                  "payment-data-source-name":
                                                    _vm.paymentOverview
                                                      .paymentDataSourceName,
                                                },
                                              },
                                              [
                                                _vm.canChangeCreditCard
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "gfu-link gfu-link--accent _mt-1",
                                                        attrs: {
                                                          href: "#",
                                                          "data-qa":
                                                            "your-pledge-link:ChangeCard",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.toggleCardChange.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.Resources
                                                              .YourPledge
                                                              .ChangePaymentMethodButton
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm.canChangeCreditCard
                                          ? [
                                              _c(
                                                "adyen-payment-context-provider",
                                                _vm._b(
                                                  {},
                                                  "adyen-payment-context-provider",
                                                  _vm.paymentConfiguration,
                                                  false
                                                ),
                                                [
                                                  _c(
                                                    "adyen-order-payment-options",
                                                    {
                                                      attrs: {
                                                        "project-id":
                                                          _vm.projectContext
                                                            .projectID,
                                                        "project-phase":
                                                          _vm.projectContext
                                                            .project.phase,
                                                        "project-type":
                                                          _vm.projectContext
                                                            .project.type,
                                                        "is-instant": false,
                                                        "require-accept-tos": false,
                                                        "effective-payable-amount":
                                                          _vm.pledge
                                                            .effectivePayableAmount,
                                                        "currency-short-name":
                                                          _vm.pledge
                                                            .currencyShortName,
                                                        "order-code":
                                                          _vm.pledge.orderCode,
                                                        "order-id":
                                                          _vm.pledge.orderID,
                                                        "payment-type":
                                                          _vm.paymentType,
                                                        reason:
                                                          _vm.paymentMethodReason,
                                                      },
                                                      on: {
                                                        "payment-error":
                                                          _vm.onPaymentError,
                                                        "payment-method-change":
                                                          _vm.onPaymentMethodChange,
                                                        "payment-method-changed":
                                                          _vm.onPaymentMethodChanged,
                                                        "toggle-payment-group-visibility-change":
                                                          _vm.onTogglePaymentGroupVisibilityChange,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "actions",
                                                            fn: function ({
                                                              onSubmit,
                                                              isProceedPaymentBlocked,
                                                              paymentMethodErrorMessage,
                                                              isProcessing,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "gfu-box-actions _mt-3",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "_ml-a",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "_tc--accent _mr-3",
                                                                            attrs:
                                                                              {
                                                                                "data-qa":
                                                                                  "create-order-btn:Cancel",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.preventDefault()
                                                                                  return _vm.toggleCardChange.apply(
                                                                                    null,
                                                                                    arguments
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .Resources
                                                                                  .YourPledge
                                                                                  .CancelPaymentMethodChangeButton
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "tooltip",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                enabled:
                                                                                  isProceedPaymentBlocked,
                                                                                text: paymentMethodErrorMessage,
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "base-button",
                                                                              {
                                                                                staticClass:
                                                                                  "gfu-btn--wide gfu-btn--soft",
                                                                                attrs:
                                                                                  {
                                                                                    theme:
                                                                                      "accent",
                                                                                    disabled:
                                                                                      isProceedPaymentBlocked ||
                                                                                      isProcessing,
                                                                                    "data-qa":
                                                                                      "create-order-btn:Submit",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    onSubmit,
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                            " +
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .Resources
                                                                                        .YourPledge
                                                                                        .SavePaymentMethodChangeButton
                                                                                    ) +
                                                                                    "\n                                                        "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2165556683
                                                      ),
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                ]
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                _vm._v(" "),
                _vm.promoItem
                  ? _c("project-promo-item", {
                      staticClass:
                        "gfu-isle gfu-isle--primary-light _pa-2 _mt-3",
                      attrs: {
                        "image-size": 48,
                        "in-context": false,
                        "data-qa": "your-pledge-project-promo-item",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isUnfinishedOrder
                  ? _c("div", { staticClass: "gfu-box-actions" }, [
                      _vm.canRevertChanges
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "gfu-box-actions__item gfu-box-actions__item--link",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "gfu-link gfu-link--accent",
                                  attrs: {
                                    "data-qa": "your-pledge-button:Revert",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.revertChanges.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.Resources.YourPledge
                                          .RevertChangesButtonLong
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAddMoreButton
                        ? _c(
                            "div",
                            { staticClass: "gfu-box-actions__item" },
                            [
                              _c(
                                "base-button",
                                {
                                  attrs: {
                                    theme: "primary",
                                    display: "fixed",
                                    shape: "soft",
                                    "data-qa": "your-pledge-button:AddItems",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.onAddItemsToOrder.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.Resources.YourPledge.AddMoreButton
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "gfu-box-actions__item _ml-a" },
                        [
                          _vm.canProceedToCheckout
                            ? _c("go-to-checkout", {
                                attrs: {
                                  "redirect-on-alternative-action": false,
                                  "continue-url": _vm.cartSummary.checkoutUrl,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ onInvoke }) {
                                        return [
                                          _c(
                                            "base-button",
                                            {
                                              attrs: {
                                                enabled:
                                                  _vm.canProceedToCheckout,
                                                theme: "accent",
                                                display: "block",
                                                "data-qa":
                                                  "your-pledge-checkout-btn",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return onInvoke.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.Resources.YourPledge
                                                      .CheckoutButton
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  896329351
                                ),
                              })
                            : _c(
                                "tooltip",
                                {
                                  attrs: {
                                    text: _vm.disabledCheckoutTooltipText,
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "gfu-btn gfu-btn--soft gfu-btn--accent gfu-btn--block",
                                      attrs: {
                                        type: "button",
                                        disabled: "disabled",
                                        "data-qa": "your-pledge-checkout-btn",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.Resources.YourPledge
                                              .CheckoutButton
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.pledge.canResumePayment
                  ? _c(
                      "div",
                      { staticClass: "gfu-box-actions" },
                      [
                        _c(
                          "base-button",
                          {
                            staticClass: "_fr _ml-a _mt-2",
                            attrs: {
                              enabled: _vm.isOrderValid,
                              theme: "accent",
                              display: "fixed",
                              "data-qa": "your-pledge-button:ResumePayment",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.onResumeOrder.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.Resources.YourPledge.ResumePaymentButton
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm.canSetShipping
                  ? _c("div", { staticClass: "gfu-box-actions" }, [
                      _c(
                        "div",
                        { staticClass: "gfu-box-actions__item _ml-a" },
                        [
                          _c("go-to-checkout", {
                            attrs: {
                              "redirect-on-alternative-action": false,
                              "continue-url":
                                _vm.cartCandidate.manageShippingUrl,
                              "order-code": _vm.cartCandidate.orderCode,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ onInvoke }) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "gfu-btn gfu-btn--soft gfu-btn--accent gfu-btn--block",
                                          attrs: {
                                            href: _vm.cartCandidate
                                              .manageShippingUrl,
                                            "data-qa":
                                              "your-pledge-checkout-btn",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return onInvoke.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.Resources.YourPledge
                                                  .SetShippingButton
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2415265915
                            ),
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isPaymentHistoryModalOpen
            ? _c("pledge-payment-history-modal", {
                attrs: {
                  "order-id": _vm.paymentHistoryOrderId,
                  "pledge-id": _vm.pledge.orderPublicID,
                  "is-open": _vm.isPaymentHistoryModalOpen,
                },
                on: { "action-close": _vm.onPaymentHistoryModalClose },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.canViewOrderStageHistory
            ? _c("order-stage-history-modal", {
                attrs: {
                  "is-open": _vm.isOrderStageHistoryModalOpen,
                  "order-id": _vm.pledge.orderID,
                  "order-public-id": _vm.pledge.orderPublicID,
                },
                on: { "action-close": _vm.onOrderStageHistoryModalClose },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("progress-overlay", { attrs: { visible: _vm.isProcessing } }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }